import './App.css'
import PasswordManager from './components/PasswordManager'

const App = () => <PasswordManager />

export default App
